import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const getOrCreateSessionId = () => {
  let sid = localStorage.getItem("sa_parts_session");
  if (!sid) {
    sid = crypto.randomUUID();
    localStorage.setItem("sa_parts_session", sid);
  }
  return sid;
};
